import { IEcommerceProduct } from './product';
import { IEcommerceService } from './service';
import { IEcommerceSpecial } from './special';

/**
 * @type {TEcommerceItem} - Union Type that joins product and service into one cart modification type
 */
export type TEcommerceItem = IEcommerceService | IEcommerceProduct | IEcommerceSpecial;

/**
 * Characterizes what kind of item it is
 * @enum {string}
 */
export enum EItemGroup {
  PRODUCT = 'product',
  GIFT = 'gift',
  UPSELLING = 'upselling',
  SERVICE = 'service',
  FREE_GIFT = 'free_gift',
  DISCOVERY_BOX = 'discovery_box',
}
